import styled from 'styled-components';

const Header = styled.header`
  align-items: center;
  display: flex;
  flex-direction: column
`;

const MobileMenuContainer = styled.div`
@media (max-width:899px) {
    color: #3ca3a0;
    display:flex;

    padding-left: 10px;
    position: absolute;
    left: 0;
  }
  box-sizing: border-box;
  letter-spacing: 0.5px;
  margin: 0;
  overflow: hidden;
  padding: 0;
  display: none;
  font-weight: 400;
`;

export {
  Header,
  MobileMenuContainer,
};
